<form [formGroup]="formGroup" novalidate #form="ngForm">
  <div>
    <glxy-form-row>
      <glxy-form-field bottomSpacing="small" [showLabel]="false">
        <textarea
          #defaultInput
          formControlName="noteBody"
          matInput
          placeholder="{{ 'ACTIVITY_LOGGER.NOTE_PLACEHOLDER' | translate }}"
          [rows]="textRows"
          cdkTextareaAutosize
          [cdkAutosizeMinRows]="textRows"
        ></textarea>
        <ng-container *ngIf="showErrors">
          <glxy-error *ngIf="formGroup.controls.noteBody.hasError('required')">
            {{ 'ACTIVITY_LOGGER.ERROR_REQUIRE_DESCRIPTION' | translate }}
          </glxy-error>
        </ng-container>
      </glxy-form-field>
    </glxy-form-row>
  </div>
  <ng-content select="[crmLoggerContent='after-description']"></ng-content>
  <div>
    <ng-content select="[crmLoggerContent='fields']"></ng-content>
  </div>
</form>
